import { createSelector } from '@ngrx/store';

import { loyaltyProgramsState } from '../root';

export const getLoyaltyPrograms = createSelector(loyaltyProgramsState, (loyaltyPrograms) => loyaltyPrograms);
